import { types, actions } from './requests'
export const DELETEBADGE_TYPES = {
    ...types('DELETEBADGE'),
}
export const DELETEBADGE_ACTIONS = {
    ...actions('DELETEBADGE'),
}